import {enumType} from '../common/enumType';

export const SmbLibrary = enumType({
   JCIFS: '6.1',
   SMBJ: '7.3',
});
